<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>Identitas Pemotong</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                {{ id_identitas_pemotong != null ? 'Edit' : 'Tambah' }} Identitas Pemotong
                            </h2>
                        </div>
                        <div class="body">
                            <form class="form-horizontal" v-on:submit.prevent="save">
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="tahun">Tahun</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="tahun" type="number" v-model="data.tahun"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="npwp">NPWP</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="npwp" type="text" v-model="data.npwp"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="nama">Nama</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="nama" type="text" v-model="data.nama"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="npwpPemotong">NPWP Pemotong</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <div class="form-group">
                                            <form-line id="npwpPemotong" type="text" v-model="data.npwpPemotong"></form-line>
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label">
                                        <label for="gambar">Gambar TTD</label>
                                    </div>
                                    <div class="col-lg-10 col-md-10 col-sm-8 col-xs-7">
                                        <img v-if="data.gambar != null" v-bind:src="data.gambar" width="150px" alt="Foto" />
                                        <div class="form-group">
                                            <input id="gambar" class="form-control" type="file" name="gambar" @change="handleFile($event)" />
                                        </div>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                                        <button v-bind:disabled="isLoading" v-if="id_identitas_pemotong != null" @click="update" type="button" class="btn btn-warning waves-effect waves-button" v-waves.button>
                                            <span v-if="!isLoading"><i class="material-icons">save</i> Edit</span>
                                            <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                                        </button>
                                        <button v-bind:disabled="isLoading" v-else @click="save" type="button" class="btn btn-primary waves-effect waves-button" v-waves.button>
                                            <span v-if="!isLoading"><i class="material-icons">save</i> Simpan</span>
                                            <span v-else><i class="fa fa-spinner fa-spin"></i> Loading</span>
                                        </button>
                                        <button @click="$router.go(-1)" type="button" class="btn btn-danger" v-waves.button><i class="material-icons">cancel</i> Batal</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import Ckeditor from 'vue-ckeditor2'
  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'

  export default {
    components: {FormLine, Ckeditor},
    name: 'FormFaq',
    data: function () {
      return {
        config: {
          toolbar: [
            { name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
            { name: 'morestuff', items: ['NumberedList', 'BulletedList'] },

            { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] },
            { name: 'colors', items: ['TextColor'] },
            { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] },
            '/',
            { name: 'document', items: ['Source'] }
          ],
          height: 300
        },
        data: {
          nama: '',
          npwp: '',
          tahun: '',
          npwpPemotong: ''
        },
        gambar: '',
        id_identitas_pemotong: '',
        isLoading: false
      }
    },
    methods: {
      save () {
        this.isLoading = true
        var form = new FormData()
        form.append('file', this.gambar)
        form.append('json', JSON.stringify(this.data))
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.post('/identitas-pemotong', form).then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/identitas-pemotong')
            this.$toastr.s('Tambah data berhasil')
          } else {
            var msg = 'Tambah data gagal'
            if (result.data.message !== '') msg = result.data.message
            this.$toastr.e(msg)
          }
          this.isLoading = false
        }).catch(e => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      },
      update () {
        var form = new FormData()
        form.append('file', this.gambar)
        form.append('json', JSON.stringify(this.data))
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.post('/identitas-pemotong/' + this.id_identitas_pemotong, form).then((result) => {
          if (result.data.code === 200) {
            this.$router.replace('/main/layanan/atur-ip')
            this.$toastr.s('Ubah data berhasil')
          }
        }).catch((e) => {
          var msg = 'Terjadi kesalahan pada server, mohon ulangi'
          if (e.response.data.message) msg = e.response.data.message
          this.$toastr.e(msg)
          this.isLoading = false
        })
      },
      getDetail () {
        api.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token')
        api.get('/identitas-pemotong/' + this.id_identitas_pemotong).then((result) => {
          this.data = result.data
        }).catch((ex) => {
          this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi')
        })
      },
      handleFile (file) {
        this.gambar = file.target.files[0]
      }
    },
    mounted () {
      this.id_identitas_pemotong = this.$route.params.id
      if (this.id_identitas_pemotong != null) {
        this.getDetail()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/IdentitasPemotong/FormIdentitasPemotong.vue?438bb287